var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mb-2"},[_c('div',{staticClass:"row justify-content-center"},[_c('table-of-contents-body',{staticClass:"col col-lg-9",attrs:{"slices":_vm.slices}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }